import { Experiment } from "@func-core/core/domain/view-models";

export const EXPERIMENT_IDS = {} as const;

export const EXPERIMENTS: Experiment[] = [];
